// Helpers para el pintado de cumpleaños en el Calendario (K1.7).
//
// Un cumpleaños es un EVENTO ANUAL RECURRENTE — se repite cada año en la misma
// fecha (MM-DD). El calendario permite navegar entre varios años, así que el
// cumple debe aparecer en TODOS los años visibles, no sólo en el próximo
// aniversario calculado con `days_until`.
//
// Rango soportado: 11 años (year - 5 a year + 5), consistente con el <select>
// de años del CalendarView (K1.4).

export const BIRTHDAY_YEARS_BACK = 5;
export const BIRTHDAY_YEARS_FWD = 5;

/**
 * Extrae el par (mm, dd) de un birthday en formato "YYYY-MM-DD".
 * Devuelve null si el formato no es válido.
 */
export function extractMonthDay(birthday) {
  if (!birthday || typeof birthday !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(birthday);
  if (!m) return null;
  const mm = Number(m[2]);
  const dd = Number(m[3]);
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return null;
  return { mm: m[2], dd: m[3] };
}

/**
 * Devuelve la lista de keys "YYYY-MM-DD" en las que un cumpleaños debe
 * pintarse. Un doc por año dentro del rango [refYear - back, refYear + fwd].
 * Casos borde:
 *  - 29/02 en año no bisiesto → se corre al 28/02 (misma convención que el
 *    backend `_days_until_birthday`).
 */
export function birthdayKeysForRange(birthday, refYear, back = BIRTHDAY_YEARS_BACK, fwd = BIRTHDAY_YEARS_FWD) {
  const md = extractMonthDay(birthday);
  if (!md) return [];
  const { mm, dd } = md;
  const keys = [];
  for (let y = refYear - back; y <= refYear + fwd; y++) {
    // Validar que la fecha exista en ese año (Feb 29 → Feb 28 en no bisiesto).
    const d = new Date(y, Number(mm) - 1, Number(dd));
    if (d.getMonth() !== Number(mm) - 1) {
      // Overflow (ej: Feb 29 en no bisiesto salta a marzo). Usar Feb 28.
      keys.push(`${y}-${mm}-28`);
    } else {
      keys.push(`${y}-${mm}-${dd}`);
    }
  }
  return keys;
}
